<template>
  <div class="page">
    <main-menu-bar/>
    <div class="page-inner">
      <screen-settings/>
    </div>
  </div>
</template>

<script>
import MainMenuBar from '../nav/MainMenuBar.vue'
import ScreenSettings from '../ScreenSettings.vue'
export default {
  name: 'SettingsPage',
  components: {
    MainMenuBar,
    ScreenSettings
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/SettingsPage.vue